const now = Date.now();
const mins = (n) => new Date(now - n * 60 * 1000).toISOString();
const hours = (n) => new Date(now - n * 60 * 60 * 1000).toISOString();
const days = (n) => new Date(now - n * 24 * 60 * 60 * 1000).toISOString();

export const WA_PREVIEW_CONVERSATIONS = [
  {
    waId: "919876543210",
    contactName: "Rahul Sharma",
    lastMessage: "Thanks, I'll confirm the booking today.",
    lastMessageAt: mins(12),
    unreadCount: 2,
  },
  {
    waId: "919123456789",
    contactName: "Priya Patel",
    lastMessage: "Can you share the itinerary PDF?",
    lastMessageAt: hours(2),
    unreadCount: 0,
  },
  {
    waId: "919998887766",
    contactName: "",
    lastMessage: "Hello, I need help with my order",
    lastMessageAt: hours(5),
    unreadCount: 1,
  },
  {
    waId: "919554433221",
    contactName: "Careveli Support",
    lastMessage: "Your refund has been processed.",
    lastMessageAt: days(1),
    unreadCount: 0,
  },
];

export const WA_PREVIEW_MESSAGES = {
  "919876543210": [
    { _id: "m1", direction: "inbound", body: "Hi, I want to book a trip to Goa next month.", messageType: "text", status: "received", createdAt: days(2) },
    { _id: "m2", direction: "outbound", body: "Hello Rahul! We'd love to help. Which dates are you looking at?", messageType: "text", status: "read", createdAt: days(2) },
    { _id: "m3", direction: "inbound", body: "Around 15th to 20th", messageType: "text", status: "received", createdAt: days(2) },
    { _id: "m4", direction: "outbound", body: "Perfect. I'll share package options shortly.", messageType: "text", status: "sent", createdAt: days(1) },
    { _id: "m5", direction: "inbound", body: "Sounds good 👍", messageType: "text", status: "received", createdAt: hours(3) },
    { _id: "m6", direction: "inbound", body: "Also need hotel near the beach", messageType: "text", status: "received", createdAt: hours(3) },
    { _id: "m7", direction: "outbound", body: "Noted! Sending beach-side hotel options now.", messageType: "text", status: "read", createdAt: hours(2) },
    { _id: "m8", direction: "inbound", body: "Thanks, I'll confirm the booking today.", messageType: "text", status: "received", createdAt: mins(12) },
  ],
  "919123456789": [
    { _id: "p1", direction: "inbound", body: "Can you share the itinerary PDF?", messageType: "text", status: "received", createdAt: hours(2) },
  ],
  "919998887766": [
    { _id: "u1", direction: "inbound", body: "Hello, I need help with my order", messageType: "text", status: "received", createdAt: hours(5) },
  ],
  "919554433221": [
    { _id: "s1", direction: "outbound", body: "Your refund has been processed.", messageType: "text", status: "sent", createdAt: days(1) },
    { _id: "s2", direction: "outbound", body: "It should reflect in 3–5 business days.", messageType: "text", status: "auto_replied", createdAt: days(1) },
  ],
};
